/**
 * @description
 * This class describes a fields prototype.
 *
 * @class   FieldsPrototype (name)
 */
export default class FieldsPrototype extends Array {
    
    /**
     * @description
     * Fields Prototype constructor
     * 
     * @param  {...any} items 
     */
    constructor(...items) {
        super(...items)
    }

    /**
     * @description
     * { function_description }
     *
     * @param      {<type>}  [fieldNames=[]]  The field names
     * @return     {<type>}  { description_of_the_return_value }
     */
    exclude(fieldNames = []) {
        return this.slice().filter( field => {
            return fieldNames.every( fieldName => {
                return field.name !== fieldName
            })
        })
    }

    /**
     * @description
     * { function_description }
     *
     * @param      {<type>}  [fieldNames=[]]  The field names
     * @return     {<type>}  { description_of_the_return_value }
     */
    include(fieldNames = []) {
        return this.slice().filter( field => {
            return fieldNames.some( fieldName => {
                return field.name == fieldName
            })
        })
    }

    prop(field, prop) {
        //
        let fieldClone = this.find(f => f.name == field)

        //
        fieldClone.props = {
            ...fieldClone.props,
            ...prop,
        }

        return this
    }

    /**
     * { function_description }
     *
     * @return     {<type>}  { description_of_the_return_value }
     */
    readonly() {
        return this.map(this.readonlyField)
    }

    /**
     * { function_description }
     *
     * @param      {<type>}  field   The field
     * @return     {<type>}  { description_of_the_return_value }
     */
    readonlyField(field) {

        //
        if (field.type === 'date-field') {
            field.props.pickerProps = field.props.pickerProps ? { ...field.props.pickerProps, readonly: true } : { readonly: true }
        } else {
            field.props.readonly = true
        }

        //
        return field
    }

    /**
     * @description
     * { function_description }
     *
     * @param      {<type>}  fieldVariant  The field variant
     * @return     {<type>}  { description_of_the_return_value }
     */
    variant(fieldVariant) {
        return this.slice().filter( field => {
            return field.variant && field.variant.some( variant => {
                return variant === fieldVariant
            })
        })        
    }
}
